import { BASE_URLS, ENVIRONMENT_MODE } from "../../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../../config/axiosInterceptor";
import { UpdateLaborRatesType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const updateLaborRate = (
  id: string,
  payload: UpdateLaborRatesType
): Promise<AxiosResponse<UpdateLaborRatesType>> => {
  return axios.patch(`${baseURL}updateLaborRate/${id}`, payload);
};
